import { sendClientRequest } from '@/utils/client-request'

export const trackVisitApi = (vendorId: string) =>
  sendClientRequest({ method: 'POST', url: '/visit', auth: false, headers: { Vendor: vendorId } as any })
